// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vdp-datepicker[data-v-0003e163]{width:100%}.grayed-out-input[data-v-0003e163]{background-color:#f0f0f0;color:#888;cursor:not-allowed;opacity:.7}[data-v-0003e163]:deep(.top.vdp-datepicker__calendar){position:absolute!important;top:-282px!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
